import React from 'react'
import ScheduleProWrapper from '../../../../SmartSchedule/SchedulePro/ScheduleProWrapper'

const CSCESPRO = (props) => {
  return (
    // <ScheduleProWrapper>
      <div className="">
        {/* <h4>Chat Support</h4> */}
        <iframe
          src={props.url}
          style={{ width: "100%", height: "70vh", border: "none" }}
          title="Chat Support"
        />
      </div>
      // </ScheduleProWrapper>
  )
}

export default CSCESPRO